import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

import { SV_URL } from '../../../@core/utils/utils';

import { UtilsProvider } from '../../../@shared/services/utils.service';

@Injectable({ providedIn: 'root' })
export class LoginProvider {

  public id: string;
  private httpDirect: HttpClient;
  constructor(
    public httpClient: HttpClient,
    handler: HttpBackend,
    public utils: UtilsProvider) {
    this.httpDirect = new HttpClient(handler);
  }

  saveLogin(data, hora, user) {
      const url: string = SV_URL + '/postLog';

      const postParams = {
        data: data,
        hora: hora ,
        user: user,
      };

      return this.utils.postHttpClient(url, postParams);

  }

  login(user, pwd) {
      const url: string = SV_URL + '/login';

      const payload = { pld: btoa(JSON.stringify({ user, pwd })) };

      return this.httpDirect
        .post<{ pld?: string }>(url, payload, { observe: 'response' })
        .toPromise();
  }


}

